import { createAction } from '@reduxjs/toolkit';

import { ShippingCountryPayload } from '@definitions/shipping.types';

const PREFIX = 'SHIPPING';

export const setShippingCountryCode = createAction<ShippingCountryPayload>(`${PREFIX}/SET_SHIPPING_COUNTRY_CODE`);
